"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _jsxRuntime = require("@emotion/react/jsx-runtime");

var _react = _interopRequireWildcard(require("react"));

var _propTypes = require("prop-types");

var _clsx = _interopRequireDefault(require("clsx"));

var _framerMotion = require("framer-motion");

var _Avatar = _interopRequireDefault(require("../../Avatar/Avatar"));

var _elements = require("../../../styles/elements");

var _Message = require("./Message.styles");

var _Bot = _interopRequireDefault(require("../Bot/Bot"));

var _TypingIndicator = _interopRequireDefault(require("../TypingIndicator/TypingIndicator"));

var _Logo = _interopRequireDefault(require("../Logo/Logo"));

var Message = function Message(_ref) {
  var children = _ref.children,
      isTyping = _ref.isTyping,
      isBot = _ref.isBot,
      displayAgent = _ref.displayAgent,
      showLogo = _ref.showLogo,
      companyName = _ref.companyName,
      showTitle = _ref.showTitle,
      agentName = _ref.agentName,
      botName = _ref.botName,
      botAvatar = _ref.botAvatar,
      avatar = _ref.avatar;
  var agent = isBot ? botName : agentName;
  var showAvatar = (0, _react.useMemo)(function () {
    if (showLogo) {
      return (0, _jsxRuntime.jsx)(_Logo["default"], {});
    }

    if (isBot && displayAgent) {
      return (0, _jsxRuntime.jsx)(_Bot["default"], {
        bot: botAvatar
      });
    }

    if (displayAgent) {
      return (0, _jsxRuntime.jsx)(_Avatar["default"], {
        size: "xl",
        avatar: avatar
      });
    }

    return false;
  }, [avatar, botAvatar, displayAgent, isBot, showLogo]);
  return (0, _jsxRuntime.jsxs)("div", {
    css: _Message.styles.base,
    className: "grui flex items-end",
    children: [(0, _jsxRuntime.jsx)(_framerMotion.motion.div, {
      animate: displayAgent || showLogo ? 'show' : 'hide',
      variants: {
        show: {
          opacity: 1
        },
        hide: {
          opacity: 0
        }
      },
      css: _Message.styles.avatarContainer,
      children: showAvatar
    }), (0, _jsxRuntime.jsxs)("div", {
      children: [showTitle && (0, _jsxRuntime.jsx)("div", {
        css: [_elements.text.styles.text2Xs, _elements.text.styles.textMediumDark, process.env.NODE_ENV === "production" ? "" : ";label:Message;"],
        className: "grui mb-3 ml-10 mt-5",
        children: displayAgent ? "".concat(agent, " from ").concat(companyName) : "".concat(companyName, " replied\u2026")
      }), (0, _jsxRuntime.jsx)("div", {
        css: _Message.styles.text,
        className: (0, _clsx["default"])('grui ml-7', isTyping && 'p-10'),
        children: isTyping ? (0, _jsxRuntime.jsx)(_TypingIndicator["default"], {}) : children
      })]
    })]
  });
};

Message.propTypes = {
  children: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.node]),
  isTyping: _propTypes.bool,
  isBot: _propTypes.bool,
  displayAgent: _propTypes.bool,
  showLogo: _propTypes.bool,
  companyName: _propTypes.string,
  showTitle: _propTypes.bool,
  agentName: _propTypes.string,
  botName: _propTypes.string,
  botAvatar: _propTypes.string,
  avatar: _propTypes.string
};
Message.defaultProps = {
  children: undefined,
  isTyping: false,
  isBot: false,
  displayAgent: false,
  showLogo: false,
  companyName: '',
  showTitle: false,
  agentName: 'Agent',
  botName: 'Bot',
  botAvatar: undefined,
  avatar: undefined
};
var _default = Message;
exports["default"] = _default;
//# sourceMappingURL=Message.js.map